"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Topic = void 0;
var mqtt_match_1 = __importDefault(require("mqtt-match"));
var Topic = /** @class */ (function () {
    function Topic(allowed) {
        if (allowed.some(function (pattern) { return /#+/g.test(pattern); })) {
            throw new Error("Not allowed to use '#' wildcard in allowed topics.");
        }
        this.allowed = allowed;
    }
    Topic.prototype.topicsFor = function (args) {
        var _this = this;
        var topics = this.buildTopics(args);
        topics.forEach(function (topic) {
            if (_this.allowed.find(function (pattern) { return (0, mqtt_match_1.default)(pattern, topic); }) == null) {
                throw new Error("Attempted to use topic '".concat(topic, "' which does not match registered patterns: ").concat(_this.allowed));
            }
        });
        return topics;
    };
    return Topic;
}());
exports.Topic = Topic;
//# sourceMappingURL=Topic.js.map